import React from "react";
import classNames from "classnames";
import styles from "./specifications-list.module.scss";
import { useLayoutType, LayoutStyleTypes, LayoutTypes } from "@/util-react/layout";

export interface SpecificationItem {
  name: string;
  value: string;
  type?: string;
}

export interface SpecificationsListProps {
  type?: LayoutStyleTypes.TYPE_LG | LayoutStyleTypes.TYPE_SM;
  options: SpecificationItem[];
  className?: string;
}

const SpecificationsList: React.FC<SpecificationsListProps> = ({
  type = LayoutStyleTypes.TYPE_LG,
  options,
  className,
}) => {
  return (
    <div className={classNames(styles.root, styles[type], className)}>
      <table className={styles.table}>
        <colgroup>
          <col className={styles.labelcol} />
          <col className={styles.valuecol} />
        </colgroup>
        <tbody>
          {options.map((item, idx) => (
            <tr className={classNames(styles.row)} key={idx}>
              <td className={classNames(styles.name)}>
                {item.name}
              </td>
              <td className={classNames(styles.value)}>
                {item.value} {item.type}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SpecificationsList;
